const SET_BILLING = 'SET_BILLING'
const SET_COUPON_CODE = 'SET_COUPON_CODE'
const SET_COUPON = 'SET_COUPON'
const SET_PLAN = 'SET_PLAN'
const SET_REFERRAL = 'SET_REFERRAL'
const SET_SHIPPING = 'SET_SHIPPING'
const SET_SAME_ADDRESS = 'SET_SAME_ADDRESS'
const CLEAR_SHIPPING = 'CLEAR_SHIPPING'
const SET_FIRST_ORDER_DETAILS = 'SET_FIRST_ORDER_DETAILS'
const SET_FREE_TRIAL = 'SET_FREE_TRIAL'
const SET_ON_LOGIN = 'SET_ON_LOGIN'
const SET_INITIAL_BAG_COUNT = 'SET_INITIAL_BAG_COUNT'
const SET_USE_STORED_CARD = 'SET_USE_STORED_CARD'

const SET_TOTALS = 'cart/SET_TOTALS'
const SET_USER = 'user/SET_USER'

export const state = () => ({
  plan: '',
  coupon: null,
  couponCode: '',
  referralCode: '',
  shipping: {},
  billing: {},
  orderDetails: {},
  didFreeTrial: false,
  isShippingConfirmed: false,
  sameAddress: true,
  useStoredCard: false,
  onLogin: false,
  initialBagCount: 0
})

export const actions = {
  async changePlan({ commit }, payload) {
    try {
      const body = { plan: payload }
      const response = await this.$axios.$post('/api/checkout/plan', body)

      commit(SET_PLAN, payload)
      commit('cart/SET_TOTALS', response, { root: true })
    } catch (err) {
      console.error(err)
    }
  },

  async applyCode({ commit }, payload) {
    const response = await this.$axios.$post(
      `/api/checkout/${payload.type}`,
      payload
    )

    if (response.result) {
      commit('mutate', {
        property: payload.property,
        with: payload.code
      })

      commit('cart/SET_TOTALS', response.totals, { root: true })
    }

    return response
  },

  async placeTrialOrder({ commit, state }) {
    const response = await this.$axios.$post('/api/checkout/trial', {
      shipping: state.shipping,
      billing: state.billing
    })

    commit(SET_USER, response.user, { root: true })
    commit(SET_TOTALS, response.totals, { root: true })
    commit(SET_ON_LOGIN, true)
    commit(SET_USE_STORED_CARD, true)

    return response
  },

  async placeOrder({ commit, state, rootGetters }) {
    const body = {
      shipping: state.shipping,
      billing: state.useStoredCard
        ? rootGetters['user/billingAddress']
        : state.billing,
      useStoredCard: state.useStoredCard
    }

    const response = await this.$axios.$post('/api/checkout/order', body)

    if (response.result) {
      commit(SET_USER, response.user, { root: true })
      commit(SET_TOTALS, response.totals, { root: true })
      commit(SET_FIRST_ORDER_DETAILS, response.orderDetails)
    }

    return response
  },

  setPlan({ commit }, payload) {
    commit(SET_PLAN, payload)
  },

  setShipping({ commit }, payload) {
    commit(SET_SHIPPING, payload)
  },

  setBilling({ commit }, payload) {
    commit(SET_BILLING, payload)
  },

  clearShipping({ commit }) {
    commit(CLEAR_SHIPPING)
  },

  setSameAddress({ commit }, payload) {
    commit(SET_SAME_ADDRESS, payload)
  },

  setFreeTrial({ commit }, payload) {
    commit(SET_FREE_TRIAL, payload)
  },

  setOnLogin({ commit }, payload) {
    commit(SET_ON_LOGIN, payload)
  },

  setCoupon({ commit }, payload) {
    commit(SET_COUPON, payload)
  },

  setCouponCode({ commit }, payload) {
    commit(SET_COUPON_CODE, payload)
  },

  setInitialBagCount({ commit }, payload) {
    commit(SET_INITIAL_BAG_COUNT, payload)
  },

  setUseStoredCard({ commit }, payload) {
    commit(SET_USE_STORED_CARD, payload)
  }
}

export const mutations = {
  mutate(state, payload) {
    state[payload.property] = payload.with
  },

  [SET_PLAN](state, payload) {
    state.plan = payload
  },

  [SET_COUPON](state, payload) {
    state.coupon = payload
  },

  [SET_COUPON_CODE](state, payload) {
    state.couponCode = payload
  },

  [SET_REFERRAL](state, payload) {
    state.referralCode = payload
  },

  [SET_BILLING](state, payload) {
    const { name, ...shippingSansName } = state.shipping

    state.billing = state.sameAddress
      ? { ...payload, ...shippingSansName }
      : payload
  },

  [SET_SHIPPING](state, payload) {
    state.shipping = payload
    state.isShippingConfirmed = true
  },

  [CLEAR_SHIPPING](state, payload) {
    state.shipping = {}
    state.isShippingConfirmed = false
  },

  [SET_SAME_ADDRESS](state, payload) {
    state.sameAddress = payload
  },

  [SET_FIRST_ORDER_DETAILS](state, payload) {
    state.orderDetails = payload
  },

  [SET_FREE_TRIAL](state, payload) {
    state.didFreeTrial = payload
  },

  [SET_ON_LOGIN](state, payload) {
    state.onLogin = payload
  },

  [SET_INITIAL_BAG_COUNT](state, payload) {
    state.initialBagCount = payload
  },

  [SET_USE_STORED_CARD](state, payload) {
    state.useStoredCard = payload
  }
}

export const getters = {
  creditCardLast4(state, getters, rootState) {
    if (state.billing.cardNumber) {
      return state.billing.cardNumber.slice(-4)
    }

    return ''
  },

  isShippingPopulated(state, getters, rootState, rootGetters) {
    return Boolean(
      state.shipping.address1 || rootGetters['user/shippingAddress'].address1
    )
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
